import { render, staticRenderFns } from "./SpecPhotosPopupWrappable.vue?vue&type=template&id=1ff854ab&scoped=true&lang=pug&"
import script from "./SpecPhotosPopupWrappable.vue?vue&type=script&lang=js&"
export * from "./SpecPhotosPopupWrappable.vue?vue&type=script&lang=js&"
import style0 from "./SpecPhotosPopupWrappable.vue?vue&type=style&index=0&id=1ff854ab&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff854ab",
  null
  
)

export default component.exports